export enum CONFIG_OPTION {
    KPI =  'KPI',
    PREDICTIVE_FAILURE = 'Predictive failure'
}

export enum IaConfigStatusHeader {
    SUCCESS = 'SUCCESS NOTIFICATION',
    FAILED = 'FAILED'
}

export enum IaConfigStatusBody {
    SUCCESS =  'Configuration successfully created.',
    FAILED = "Configuration failed",
    UPDATE_SUCCESS = "Changes were saved successfully",
    UPDATE_FAILED = "Changes were not saved successfully",
    DELETE_SUCCESS = 'Configuration has been deleted successfully.',
    DELETE_FAILED = 'Configuration was not deleted successfully.'
}

export enum CONFIG_TYPE {
    KPI =  'KPI_Based_Monitoring_Rule',
    PREDICTIVE_FAILURE = 'Predictive_Control_Valve_Failure',
    CUSTOM_PREDICTIVE = 'Custom_Insight_Category',
    EWB_CONFIGURATION = 'Anomaly_Detection',
    ML_ANOMALY_DETECTION = 'ML_Anomaly_detection'
}

export enum CONFIG_TYPE_URL {
    KPI =  '/home/kpi/',
    PREDICTIVE_FAILURE = '/home/predictive/',
    EWB_CONFIGURATION = '/home/ewbconfiguration/'
}

export enum CONFIG_MODE {
    CREATE,
    EDIT 
}
